var map = {
	"./music-instructions.json": 4297,
	"./music-library-intro2024.json": 4298,
	"./music-library-launch2024.json": 4299,
	"./music-progression.json": 4300,
	"./startSourcesAdvanced.json": 4301,
	"./startSourcesSimple.json": 4302,
	"./startSourcesSimple2.json": 4303,
	"./startSourcesTracks.json": 4304
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4036;